import type { PainPointOption } from '@/data/painPoints'

interface PainCardProps {
  option: PainPointOption
  selected: boolean
  onToggle: () => void
}

/** Toggleable pain-point card with Lucide icon + label + checkbox indicator. */
export function PainCard({ option, selected, onToggle }: PainCardProps) {
  const { Icon } = option
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={selected}
      className={`fq-pain-card${selected ? ' is-selected' : ''}`}
      onClick={onToggle}
    >
      <span className="fq-pain-glyph" aria-hidden="true">
        <Icon size={18} strokeWidth={2} />
      </span>
      <span className="fq-pain-label">{option.label}</span>
      <span className={`fq-pain-check${selected ? ' is-on' : ''}`} aria-hidden="true" />
    </button>
  )
}
